import React from 'react';
import { Layout } from 'antd';
import withSession from 'hoc/withSession';
import { Outlet, useLocation } from 'react-router-dom';
import Header from '../../components/Header/Header';
import Sidebar from '../../components/Sidebar/Sidebar';
import './dashboard.css';

const Dashboard: React.FC = () => {
  const location = useLocation();
  const isLoggedIn: boolean = localStorage.getItem('sessionToken') !== null;

  return (
    <Layout style={{backgroundColor: '#0E1730'}}>
      <Header />
      <div className="container">
        <div className="site-layout">
          <Sidebar />
          <main className={'site-layout__main' + (location.pathname === '/score' ? ' site-layout__main--score' : '')}>
            { isLoggedIn && <Outlet />}
          </main>
        </div>
      </div>
    </Layout>
  );
};

export default withSession(Dashboard);
